module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.f363a1c0.woff2";